var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
/* tslint:disable: no-non-null-assertion */
import { Jackpot } from ".";
import { computed, observable, action } from "mobx";
import { TimeHelpers } from "../../../helpers";
import { DateFromISO } from "sb-js-extends";
DateFromISO();
export var JackpotBlockDateStyle;
(function (JackpotBlockDateStyle) {
    JackpotBlockDateStyle[JackpotBlockDateStyle["Countdown"] = 1] = "Countdown";
    JackpotBlockDateStyle[JackpotBlockDateStyle["Regular"] = 2] = "Regular";
})(JackpotBlockDateStyle || (JackpotBlockDateStyle = {}));
export class BlockConfiguration {
    constructor(cmsConfig, jackpot) {
        this.currentTimeZone = 0;
        this.id = cmsConfig.Id;
        this.jackpotId = cmsConfig.JackpotId;
        this.name = cmsConfig.JackpotName;
        this.IsJackpotNameVisible = !!cmsConfig.IsJackpotNameVisible; //cms return boolean as 0 or 1
        this.description = cmsConfig.JackpotDescription;
        this.image = cmsConfig.BackgroundImage ? cmsConfig.BackgroundImage : undefined;
        this.animationBottomLeft = cmsConfig.AnimationBottomLeft ? cmsConfig.AnimationBottomLeft : undefined;
        this.animationTopRight = cmsConfig.AnimationTopRight ? cmsConfig.AnimationTopRight : undefined;
        this.dateStyle = cmsConfig.DateStyle;
        this.showPopupBtn = !!cmsConfig.ShowPopupBtn; //cms return boolean as 0 or 1
        this.popupBtnTextForAnonymousUser = cmsConfig.PopupBtnTextForAnonymousUser;
        this.popupBtnTextForLoggedInUser = cmsConfig.PopupBtnTextForLoggedInUser;
        this.popupBtnLinkForAnonymousUser = cmsConfig.PopupBtnLinkForAnonymousUser;
        this.popupBtnLinkForAnonymousUserDesktop = cmsConfig.PopupBtnLinkForAnonymousUserDesktop;
        this.popupBtnLinkForLoggedInUser = cmsConfig.PopupBtnLinkForLoggedInUser;
        this.termsHeader = cmsConfig.TermsHeader;
        this.terms = cmsConfig.Terms;
        this.updatingData = jackpot;
        this.timeFormat = cmsConfig.TimeFormat;
        this.showPopup = false;
        this.showBottomLinkBtn = false;
    }
    get IsCountdownType() {
        return this.dateStyle === JackpotBlockDateStyle.Countdown;
    }
    get CountdownState() {
        let result = {
            isMoreThan24hLeft: true,
            parts: []
        };
        if (!this.updatingData.maxDropDate || !this.IsCountdownType) {
            return result;
        }
        var delta = Math.abs(this.updatingData.maxDropDate.getTime() - this.updatingData.lastUpdateTime) / 1000;
        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400);
        delta -= days * 86400;
        // calculate (and subtract) whole hours
        var hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;
        // calculate (and subtract) whole minutes
        var minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;
        if (days > 0) {
            result.parts.push(...[days, hours, minutes]);
            return result;
        }
        // what's left is seconds
        let seconds = Math.floor(delta % 60);
        result.isMoreThan24hLeft = false;
        result.parts.push(...[hours, minutes, seconds]);
        return result;
    }
    get Name() {
        return this.IsJackpotNameVisible ? this.name ? this.name : this.updatingData.name : "";
    }
    get Description() {
        return this.description ? this.description : this.updatingData.description;
    }
    /* istanbul ignore next */
    get MustDropBeforeDate() {
        if (!this.updatingData.maxDropDate) {
            return "";
        }
        let date = new Date(this.updatingData.maxDropDate);
        let dateInfo = TimeHelpers.prepareEventDateInfo(date);
        let dateText = UseMonthName ? dateInfo.adjustedDateText : dateInfo.dateDigits;
        let dateWithCurrentTimeZone = TimeHelpers.addCurrentTimeZoneHours(this.currentTimeZone, date);
        let timeText = dateWithCurrentTimeZone.toStringEx(this.timeFormat);
        return `${dateText} ${timeText}`;
    }
    updateTimeZone(currentTimeZone) {
        this.currentTimeZone = currentTimeZone;
    }
    setShowPopup(flag) {
        if (flag && this.updatingData.IsWon) {
            return;
        } //skip only open for won JP
        this.showPopup = flag;
    }
    /* istanbul ignore next */
    setShowBottomPopupBtn(flag) {
        this.showBottomLinkBtn = flag;
    }
    /* istanbul ignore next */
    closePopup() {
        this.setShowPopup(false);
        this.setShowBottomPopupBtn(false);
    }
    getPopupButtonLink(isUserLoggedIn, isDesktop) {
        let popupBtnLinkForAnonymousUser = isDesktop
            ? this.popupBtnLinkForAnonymousUserDesktop
            : this.popupBtnLinkForAnonymousUser;
        return isUserLoggedIn ? this.popupBtnLinkForLoggedInUser : popupBtnLinkForAnonymousUser;
    }
    getPopupButtonName(isUserLoggedIn) {
        return isUserLoggedIn ? this.popupBtnTextForLoggedInUser : this.popupBtnTextForAnonymousUser;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], BlockConfiguration.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Jackpot)
], BlockConfiguration.prototype, "updatingData", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], BlockConfiguration.prototype, "showPopup", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], BlockConfiguration.prototype, "showBottomLinkBtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], BlockConfiguration.prototype, "currentTimeZone", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockConfiguration.prototype, "CountdownState", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BlockConfiguration.prototype, "Name", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BlockConfiguration.prototype, "Description", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BlockConfiguration.prototype, "MustDropBeforeDate", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], BlockConfiguration.prototype, "updateTimeZone", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], BlockConfiguration.prototype, "setShowPopup", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], BlockConfiguration.prototype, "setShowBottomPopupBtn", null);
//# sourceMappingURL=BlockConfiguration.js.map